import { setGasCalculation, setChargePump1CorrectionFactors, setChargePump2CorrectionFactors, setChargePump2Selected, setChargePump3CorrectionFactors, setChargePump3Selected, setChargePumpList, setChargePumpList2, setChargePumpList3, setChargePumpSelected, setDesiredNoOfStages1, setDesiredNoOfStages2, setDesiredNoOfStages3, setExistedGasSepEquipments, setGasAnchorID, setGasAnchorOD, setGasDesign, setGasHandler, setGasHandlerEquipmentsDropdown, setGasIntakeNaturalEff, setGasPowerRating, setGasSeparatorList, setGasSeparatorsEquipmentDropdown, setGasTubingOD, setGasTubingODList, setNoOfSeparators, setSelectedGasSeparator, setTypeOfShaft, setTypeOfShaft1, setTypeOfShaft2, setTypeOfShaft3, setUseChargePump, setUseGasHandler, setChargePumpName, setChargePump2Name, setChargePump3Name, setExistedGasHandlerEquipments, setExistedSRGasPump1Equipments, setExistedSRGasPump2Equipments, setExistedSRGasPump3Equipments, setGasGKXCorrectionFactors, setGasCalculationComplete, setGasGKXList, fetchGasSeparatorEquipments, setSepName, fetchEquipmentsGasHandler, setShowHideGasHandlerEquipment, fetchEquipmentsChargePumpOne, fetchEquipmentsChargePumpTwo, fetchEquipmentsChargePumpThree, setGasCalculationOutput, setShowHideGasSeparatorEquipment, setShowHideSRGasPump1Equipment, setShowHideSRGasPump2Equipment, setShowHideSRGasPump3Equipment, setGasNotification, gasCalculationStart } from "../../../store/calculation/calculation-output/gasCalculaionSlice";
import { useAppDispatch } from "../../../store/hooks/StoreHooks"
import { BasicGasCalculation } from "../../../store/model/calculations/calculation"
import { setBasicCalculationComplete } from "../../../store/calculation/calculation-output/basicCalculationSlice";
import { setHiddenChargePumpSelected, setHiddenChargePumpSelected2, setHiddenChargePumpSelected3, setHiddenDesrdStg, setHiddenDesrdStg2, setHiddenDesrdStg3 } from "../../../store/calculation/calculation-input/TubingSlice";
import { useGasHandlerFacade } from "./gas-handler.facade";
import { setPumpCalculationComplete } from "../../../store/calculation/calculation-output/pumpSlice";
import { setMotorCalculationComplete } from "../../../store/calculation/calculation-output/motorSlice";
import { setCableCalculationComplete } from "../../../store/calculation/calculation-output/cableSlice";
import { setSurfaceCalculationComplete } from "../../../store/calculation/calculation-output/surfaceEquipmentSlice";

export const useGasCalculationFacade = () => {
    const dispatch = useAppDispatch();
    const { updateGKXDataHandler, updateCP1CalculationData, updateCP2CalculationData, updateCP3CalculationData } = useGasHandlerFacade();

    const loadGasCalculations = (payload: BasicGasCalculation) => {
        return dispatch(setGasCalculation(payload));
    };

    const updateGasCalculationOutput = (payload: any) => {
        return dispatch(setGasCalculationOutput(payload));
    };

    const GasCalculationStart = () => {
        dispatch(setGasCalculationComplete(false));
        dispatch(setBasicCalculationComplete(false));
        dispatch(setPumpCalculationComplete(false));
        dispatch(setMotorCalculationComplete(false));
        dispatch(setCableCalculationComplete(false));
        dispatch(setSurfaceCalculationComplete(false));
        dispatch(gasCalculationStart());
    };

    const updateGasDesign = (payload: string) => {
        return dispatch(setGasDesign(payload));
    };

    const updateNoOfSeparators = (payload: string) => {
        dispatch(setSurfaceCalculationComplete(false));
        dispatch(setNoOfSeparators(payload));
        if (payload === "") {
            updateSelectedSeparator("");
            updateSepName("");
        }
    };

    const updateSeparatorList = (payload: any) => {
        return dispatch(setGasSeparatorList(payload));
    };

    const updateSelectedSeparator = (payload: string) => {
        dispatch(setSurfaceCalculationComplete(false));
        dispatch(setSelectedGasSeparator(payload));
    };

    const updateSepName = (payload: string) => {
        return dispatch(setSepName(payload));
    };

    const updateGasAnchorOD = (payload: string) => {
        return dispatch(setGasAnchorOD(payload));
    };

    const updateGasTubingOD = (payload: string) => {
        dispatch(setSurfaceCalculationComplete(false));
        dispatch(setGasTubingOD(payload));
    };

    const updateGasAnchorID = (payload: string) => {
        return dispatch(setGasAnchorID(payload));
    };

    const updateTubingODList = (payload: any) => {
        return dispatch(setGasTubingODList(payload));
    };

    const updateUseGasHandler = (payload: string) => {
        dispatch(setSurfaceCalculationComplete(false));
        dispatch(setUseGasHandler(payload));
    };

    const updateGasHandler = (payload: string) => {
        dispatch(setSurfaceCalculationComplete(false));
        dispatch(setGasHandler(payload));
    };

    const updateGasGKXList = (payload: any) => {
        return dispatch(setGasGKXList(payload))
    };

    const updateTypeOfShaft = (payload: number | string) => {
        return dispatch(setTypeOfShaft(payload));
    }

    const updateGasPowerRating = (value: string | number) => {
        return dispatch(setGasPowerRating(value));
    };

    const updateUseChargePump = (payload: string) => {
        dispatch(setUseChargePump(payload));
        if (payload === '0') {
            dispatch(setSurfaceCalculationComplete(false));
            SetChargePump('');
        }
    };

    const updateChargePumpList1 = (payload: any) => {
        return dispatch(setChargePumpList(payload));
    };

    const updateChargePumpList2 = (payload: any) => {
        return dispatch(setChargePumpList2(payload));
    };

    const updateChargePumpList3 = (payload: any) => {
        return dispatch(setChargePumpList3(payload));
    };

    const updateSelectedChargePump1 = (payload: string) => {
        return dispatch(setChargePumpSelected(payload));
    };

    const updateSelectedChargePump2 = (payload: string) => {
        return dispatch(setChargePump2Selected(payload));
    };

    const updateSelectedChargePump3 = (payload: string) => {
        return dispatch(setChargePump3Selected(payload));
    };

    const updateSelectedTypeOfShaft1 = (payload: number) => {
        return dispatch(setTypeOfShaft1(payload));
    };

    const updateSelectedTypeOfShaft2 = (payload: number) => {
        return dispatch(setTypeOfShaft2(payload));
    };

    const updateSelectedTypeOfShaft3 = (payload: number) => {
        return dispatch(setTypeOfShaft3(payload));
    };

    const updateDesiredNoOfStages1 = (payload: string | number) => {
        return dispatch(setDesiredNoOfStages1(payload));
    };

    const updateDesiredNoOfStages2 = (payload: string | number) => {
        return dispatch(setDesiredNoOfStages2(payload));
    };

    const updateDesiredNoOfStages3 = (payload: string | number) => {
        return dispatch(setDesiredNoOfStages3(payload));
    };

    const updateGasIntakeNaturalEff = (payload: string) => {
        return dispatch(setGasIntakeNaturalEff(payload));
    };

    const loadGasSeparatorEquipmentDropdown = (payload: any) => {
        return dispatch(setGasSeparatorsEquipmentDropdown(payload));
    };

    const updateShowHideGasSepEquipments = (payload: boolean) => {
        return dispatch(setShowHideGasSeparatorEquipment(payload));
    };

    const updateExistedGasSeparatorEquipments = (equipments: any) => {
        return dispatch(setExistedGasSepEquipments(equipments));
    };

    const updateExistedGasHandlerEquipments = (equipments: any) => {
        return dispatch(setExistedGasHandlerEquipments(equipments));
    };

    const updateShowHideGasHandlerEquipments = (payload: boolean) => {
        return dispatch(setShowHideGasHandlerEquipment(payload));
    };

    const existedChargePump1Equipments = (equipments: any) => {
        return dispatch(setExistedSRGasPump1Equipments(equipments));
    };

    const updateShowHidePump1Equipments = (payload: boolean) => {
        return dispatch(setShowHideSRGasPump1Equipment(payload));
    };

    const existedChargePump2Equipments = (equipments: any) => {
        return dispatch(setExistedSRGasPump2Equipments(equipments));
    };

    const updateShowHidePump2Equipments = (payload: boolean) => {
        return dispatch(setShowHideSRGasPump2Equipment(payload));
    };

    const existedChargePump3Equipments = (equipments: any) => {
        return dispatch(setExistedSRGasPump3Equipments(equipments));
    };

    const updateShowHidePump3Equipments = (payload: boolean) => {
        return dispatch(setShowHideSRGasPump3Equipment(payload));
    };

    const loadGasHandlerEquipmentList = (payload: any) => {
        return dispatch(setGasHandlerEquipmentsDropdown(payload));
    };

    const loadChargePump1EquipmentList = () => {
        return dispatch(fetchEquipmentsChargePumpOne());
    };

    const loadChargePump2EquipmentList = () => {
        return dispatch(fetchEquipmentsChargePumpTwo());
    };

    const loadChargePump3EquipmentList = () => {
        return dispatch(fetchEquipmentsChargePumpThree());
    };

    const updateChargePumpName = (payload: string) => {
        return dispatch(setChargePumpName(payload));
    };
    const updateChargePump2Name = (payload: string) => {
        return dispatch(setChargePump2Name(payload));
    };
    const updateChargePump3Name = (payload: string) => {
        return dispatch(setChargePump3Name(payload));
    };

    const OverrideCorrectionFactorsForGKX = (correctionFactors: { flowCorrection: number, headCorrection: number, powerCorrection: number }) => {
        return dispatch(setGasGKXCorrectionFactors(correctionFactors));
    };

    const OverrideCorrectionFactorsForChargePump1 = (correctionFactors: { flowCorrection: number, headCorrection: number, powerCorrection: number }) => {
        return dispatch(setChargePump1CorrectionFactors(correctionFactors));
    };

    const OverrideCorrectionFactorsForChargePump2 = (correctionFactors: { flowCorrection: number, headCorrection: number, powerCorrection: number }) => {
        return dispatch(setChargePump2CorrectionFactors(correctionFactors));
    };

    const OverrideCorrectionFactorsForChargePump3 = (correctionFactors: { flowCorrection: number, headCorrection: number, powerCorrection: number }) => {
        return dispatch(setChargePump3CorrectionFactors(correctionFactors));
    };

    const loadEquipmentsGasHandler = () => {
        return dispatch(fetchEquipmentsGasHandler());
    };

    const loadGasSeparatorEquipments = () => {
        return dispatch(fetchGasSeparatorEquipments());
    };

    const SetChargePump = (payload: string) => {
        dispatch(setSurfaceCalculationComplete(false));
        dispatch(setChargePumpSelected(payload));
        dispatch(setHiddenChargePumpSelected(payload));
        if (payload === '') {
            updateSelectedChargePump1("");
            SetChargePumpDesrdStge('');
            SetChargePump2('');
            updateChargePumpName("");
            updateCP1CalculationData(null);
        }
    };

    const SetChargePump2 = (payload: string) => {
        dispatch(setSurfaceCalculationComplete(false));
        dispatch(setChargePump2Selected(payload));
        dispatch(setHiddenChargePumpSelected2(payload));
        if (payload === '') {
            updateSelectedChargePump2("");
            SetChargePumpDesrdStge2('');
            SetChargePump3('');
            updateChargePump2Name("");
            updateCP2CalculationData(null);
        }
    };

    const SetChargePump3 = (payload: string) => {
        dispatch(setSurfaceCalculationComplete(false));
        dispatch(setChargePump3Selected(payload));
        dispatch(setHiddenChargePumpSelected3(payload));
        if (payload === '') {
            updateSelectedChargePump3("");
            SetChargePumpDesrdStge3('');
            updateChargePump3Name("");
            updateCP3CalculationData(null);
        }
    };

    const SetChargePumpDesrdStge = (payload: string) => {
        dispatch(setSurfaceCalculationComplete(false));
        dispatch(setDesiredNoOfStages1(payload));
        dispatch(setHiddenDesrdStg(payload));
    };

    const SetChargePumpDesrdStge2 = (payload: string) => {
        dispatch(setSurfaceCalculationComplete(false));
        dispatch(setDesiredNoOfStages2(payload));
        dispatch(setHiddenDesrdStg2(payload));
    };

    const SetChargePumpDesrdStge3 = (payload: string) => {
        dispatch(setSurfaceCalculationComplete(false));
        dispatch(setDesiredNoOfStages3(payload));
        dispatch(setHiddenDesrdStg3(payload));
    };

    const updateGasNotification = (payload: any) => {
        return dispatch(setGasNotification(payload));
    };

    const resetGKXData = () => {
        updateGKXDataHandler(null);
        const GasCalculationOutPut = {
            GKX_HPRating: 0
        };
        updateGasCalculationOutput(GasCalculationOutPut);
    };

    const resetCP1Data = () => {
        updateCP1CalculationData(null);
        const GasCalculationOutPut = {
            CP1_HPRating: 0,
            CP2_HPRating: 0,
            CP3_HPRating: 0
        };
        updateGasCalculationOutput(GasCalculationOutPut);
    };

    const resetCP2Data = () => {
        updateCP2CalculationData(null);
        const GasCalculationOutPut = {
            CP2_HPRating: 0,
            CP3_HPRating: 0
        };
        updateGasCalculationOutput(GasCalculationOutPut);
    };

    const resetCP3Data = () => {
        updateCP3CalculationData(null);
        const GasCalculationOutPut = {
            CP3_HPRating: 0
        };
        updateGasCalculationOutput(GasCalculationOutPut);
    };

    return {
        loadGasCalculations,
        updateGasCalculationOutput,
        updateGasDesign,
        updateNoOfSeparators,
        updateSelectedSeparator,
        updateSepName,
        updateSeparatorList,
        updateGasAnchorOD,
        updateGasTubingOD,
        updateGasAnchorID,
        updateTubingODList,
        updateUseGasHandler,
        updateGasHandler,
        updateTypeOfShaft,
        updateGasPowerRating,
        updateUseChargePump,
        updateChargePumpList1,
        updateChargePumpList2,
        updateChargePumpList3,
        updateSelectedChargePump1,
        updateSelectedChargePump2,
        updateSelectedChargePump3,
        updateSelectedTypeOfShaft1,
        updateSelectedTypeOfShaft2,
        updateSelectedTypeOfShaft3,
        updateDesiredNoOfStages1,
        updateDesiredNoOfStages2,
        updateDesiredNoOfStages3,
        updateGasGKXList,
        loadGasSeparatorEquipments,
        loadGasHandlerEquipmentList,
        updateGasIntakeNaturalEff,
        OverrideCorrectionFactorsForGKX,
        OverrideCorrectionFactorsForChargePump1,
        OverrideCorrectionFactorsForChargePump2,
        OverrideCorrectionFactorsForChargePump3,
        updateChargePumpName,
        updateChargePump2Name,
        updateChargePump3Name,
        updateExistedGasSeparatorEquipments,
        updateShowHideGasSepEquipments,
        updateExistedGasHandlerEquipments,
        updateShowHideGasHandlerEquipments,
        existedChargePump1Equipments,
        updateShowHidePump1Equipments,
        existedChargePump2Equipments,
        updateShowHidePump2Equipments,
        existedChargePump3Equipments,
        updateShowHidePump3Equipments,
        loadGasSeparatorEquipmentDropdown,
        GasCalculationStart,
        SetChargePumpDesrdStge,
        SetChargePumpDesrdStge2,
        SetChargePumpDesrdStge3,
        SetChargePump,
        SetChargePump2,
        SetChargePump3,
        loadEquipmentsGasHandler,
        loadChargePump1EquipmentList,
        loadChargePump2EquipmentList,
        loadChargePump3EquipmentList,
        updateGasNotification,
        resetGKXData,
        resetCP1Data,
        resetCP2Data,
        resetCP3Data,
    }
};